export const RADIUS_KM = 25;

export const CATEGORIES = [
  "Fiction", "Non-Fiction", "Mystery & Thriller", "Sci-Fi & Fantasy",
  "Romance", "Biography", "History", "Science", "Self-Help",
  "Children's", "Young Adult", "Comics & Graphic Novels", "Poetry", "Religious", "Other",
] as const;

export const AGE_GROUPS = [
  "Children (0-12)", "Teen (13-17)", "Young Adult (18-25)",
  "Adult (26-50)", "Senior (50+)", "All Ages",
] as const;

export const DURATIONS = [
  "1 Day", "3 Days", "1 Week", "2 Weeks", "1 Month", "3 Months", "6 Months",
] as const;

export const CONDITIONS = ["Like New", "Good", "Fair", "Worn"] as const;

export function distanceKm(lat1: number, lng1: number, lat2: number, lng2: number) {
  const R = 6371;
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

// --- Exchange modes -------------------------------------------------------
export type ExchangeMode = "swap" | "lend" | "donate";

export const EXCHANGE_MODES: { value: ExchangeMode; label: string; labelAr: string; hint: string; hintAr: string; emoji: string }[] = [
  {
    value: "swap",
    label: "Swap",
    labelAr: "تبادل",
    hint: "You trade this book for one of theirs.",
    hintAr: "تبادل هذا الكتاب مقابل كتاب من عندهم.",
    emoji: "🔁",
  },
  {
    value: "lend",
    label: "Lend",
    labelAr: "إعارة",
    hint: "You want the book back after a set period.",
    hintAr: "تريد استعادة الكتاب بعد مدة محددة.",
    emoji: "📚",
  },
  {
    value: "donate",
    label: "Donate",
    labelAr: "تبرع",
    hint: "You're giving the book away for good — it leaves Book Swap once handed over.",
    hintAr: "أنت تتبرع بالكتاب نهائيًا — ويُزال من التطبيق بعد التسليم.",
    emoji: "💝",
  },
];

export function modeLabel(mode: string | null | undefined, lang: "en" | "ar" = "en") {
  const m = EXCHANGE_MODES.find((x) => x.value === (mode ?? "swap"));
  if (!m) return "";
  return `${m.emoji} ${lang === "ar" ? m.labelAr : m.label}`;
}

// --- Saudi Arabia localization -------------------------------------------
export const COUNTRY = "Saudi Arabia";
export const COUNTRY_AR = "المملكة العربية السعودية";
export const PHONE_PLACEHOLDER = "+966 5X XXX XXXX";
export const PHONE_COUNTRY_CODE = "+966";

export const SAUDI_CITIES = [
  "Riyadh", "Jeddah", "Mecca", "Medina", "Dammam", "Khobar",
  "Abha", "Tabuk", "Jubail", "Taif", "Buraidah", "Hail", "Najran", "Yanbu",
] as const;

export const ADDRESS_PLACEHOLDER = "Neighborhood, Riyadh, Saudi Arabia";
